import "./styles/global.css";

import Navbar from "./components/Navbar/Navbar";
import Hero from "./components/Hero/Hero";
import Services from "./components/Services/Services";
import StatsBand from "./components/StatsBand/StatsBand";
import HowItWorks from "./components/HowItWorks/HowItWorks";
import Benefits from "./components/Benefits/Benefits";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";

export default function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <Services />
      <StatsBand />
      <HowItWorks />
      <Benefits />
      <Contact />
      <Footer />
    </>
  );
}
